/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams } from "../models/UsersAuthzAPIUserPermissionsReadCheckUserPermission";

function getUsersAuthzAPIUserPermissionsReadCheckUserPermissionUrl(permission: UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams["permission"]) {
  const res = { method: 'GET', url: `/user/permissions/${permission}` as const }  
  return res
}

/**
 * @summary Check if the current user has a specific permission
 * {@link /user/permissions/:permission}
 */
export async function usersAuthzAPIUserPermissionsReadCheckUserPermission(permission: UsersAuthzAPIUserPermissionsReadCheckUserPermissionPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIUserPermissionsReadCheckUserPermissionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getUsersAuthzAPIUserPermissionsReadCheckUserPermissionUrl(permission).url.toString(), ... requestConfig })  
  return res.data
}